import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, AttachmentAssignmentDTO, AttachmentDTO } from '../../../../services/api/api';
import { ModalNavigationService } from '../../../../services/gui/modal/modal-navigation.service';
import { Entity } from '../../../../services/global/global-interfaces';
import { ToasterService, ToastType } from '../../../../services/toaster/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-attachment-link',
  templateUrl: './attachment-link.component.html',
  styleUrls: ['./attachment-link.component.scss'],
  standalone: false,
})
export class AttachmentLinkComponent implements OnInit {
  attachment: AttachmentDTO;
  entity: Entity;

  selectedTable: string;

  constructor(
    private toaster: ToasterService,
    private api: API,
    private navigationModal: ModalNavigationService,
    private translate: TranslateService,
    private destroyRef: DestroyRef
  ) {
    this.selectedTable = 'device';
  }

  ngOnInit(): void {
    this.attachment = this.navigationModal.getCurrentNavigation().data;
  }

  linkToEntry() {
    if (this.entity) {
      const attachmentAttach: AttachmentAssignmentDTO = new AttachmentAssignmentDTO();
      attachmentAttach.isPublic = true;
      attachmentAttach.attachment = this.attachment;
      this.api
        .shared_Attachment_attachToEntity(this.entity.entity, this.entity.entityId, [attachmentAttach])
        .pipe(takeUntilDestroyed(this.destroyRef), take(1))
        .subscribe({
          next: () => {
            this.toaster.toast(ToastType.SUCCESS, this.translate.instant('lang.globals.successful') + '!');
            this.navigationModal.result(true);
          },
        });
    }
  }

  handleSelection(obj: any, entityStr: string) {
    if (obj && entityStr) {
      this.entity = {
        entity: entityStr,
        entityId: obj.id,
      };
      this.linkToEntry();
    }
  }
}
